import { withInstall } from '@xzx-design/utils'
import _Cell from './src/cell'
import _CellGroup from './src/cell-group'

export const Cell = withInstall(_Cell)
export default Cell
export const CellGroup = withInstall(_CellGroup)

export * from './src/cell'
